var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
export const useAnnounceOnChange = (value) => {
    _react_refresh_temp_1();
    const [unchanged, setUnchanged] = useState({
        value,
    });
    const isUnchanged = unchanged !== null && value === unchanged.value;
    if (unchanged !== null && !isUnchanged) {
        setUnchanged(null);
    }
    return isUnchanged ? undefined : value;
};
_react_refresh_temp_1(useAnnounceOnChange, "wuLuSDx6Bad9ATXqTBruPzVr9Po=");
